import { GIFT_CERTIFICATES_EXCLUDED_PATHS } from '../config/giftCertificates';

export function shouldHideGiftCertificatesBanner(pathname: string): boolean {
  return GIFT_CERTIFICATES_EXCLUDED_PATHS.some((path) => pathname.includes(path));
}
